<template>

	<div v-if="results">

		<transition name="slide">
			<div class="g-cart-toast g-layout g-layout--no-wrap g-layout--align-center" ref="toast" v-show="result.id">
				<div class="g-cart-toast__image-wrap g-layout__item no-grow no-padding">
					<img v-lazy="{ src: result.thumbnailImageUrl, error: errorImage, loading: loadingImage }" :alt="'Image for ' + result.name" />
				</div>
				<div class="g-layout__item">
					<div v-if="success == true" class="g-cart-toast-message is-success">
						+{{ quantity }} Successfully Added to Cart!
					</div>
					<div v-else v-html="message" class="g-cart-toast-message is-warning"></div>
					<div class="g-cart-toast-name" v-html="result.name"></div>
				</div>
				<div class="g-layout__item no-grow">
					<a :href="basketUrl" class="g-cart-toast-cta g-button g-button--hollow">
						<span>View Cart</span>
						<span class="u-hidden u-inline--l">&amp; Checkout</span>
					</a>
				</div>
			</div>
		</transition>

	</div>

</template>

<script>

	import EventBus from '@mvps-genesis/event-bus';

	export default {
		data() {
			return {
				result: {},
				quantity: null,
				basketUrl: mivaJS.Basket_Url,
				errorImage: mivaJS.Image_Placeholder_Product,
				loadingImage: mivaJS.Image_Placeholder_Product_Empty,
				message: null,
				success: null,
				timer: null
			}
		},
		props: {
			results: {
				default() {
					return {}
				}
			}
		},
		created() {

			EventBus.addEventListener( 'MVPS:addToCart', ( e ) => {

				const formData = e.detail.formData;

				this.setResult( formData.get( 'Product_Code' ), formData.get( 'Quantity' ), e.detail.message, e.detail.success );

			});

		},
		methods: {
			setResult( productCode, quantity, message, success ) {

				this.message = message;

				this.success = success;

				this.quantity = quantity;

				this.result = this.results.find( result => result.code == productCode );

				// set top value based on header
				// FOR TESTING ONLY -- DO NOT USE IN PRODUCTION
				// this.$refs.toast.style.top = `${ (document.querySelector( '[data-hook="site-header"]' ).offsetHeight + 15) / 16 }rem`;

				// hide after x ms
				if ( this.timer ) {
					clearTimeout( this.timer );
				}
				this.timer = setTimeout( this.resetResult.bind( this ), 10000 );

			},
			resetResult() {

				this.quantity = null;

				this.result = {};

			}
		}
	}

</script>

<style lang="scss" scoped>

	@import "variables";

	.g-cart-toast {
		background: $white;
		box-shadow: 0 2px 14px 1px rgba( 0,0,0, 0.09 );
		left: 0;
		margin: 0;
		padding: $unit-small 10px;
		position: fixed;
		top: 0;
		width: 100%;
		z-index: $layers-4;

		img {
			max-height: 100%;
		}

		@include media( ">=small" ) {
			border-radius: $radius-medium;
			left: auto;
			padding: 12px $unit;
			right: 15px;
			top: 162px;
			width: 513px;
		}

		@include media( ">=medium" ) {
			top: 146px;
		}
	}

	.no-grow {
		flex: 0 0 auto;
	}

	.no-padding {
		padding: 0;
	}

	.g-cart-toast__image-wrap {
		align-items: center;
		display: flex;
		height: 65px;
		justify-content: center;
		width: 55px;

		@include media( ">large" ) {
			height: 73px;
			width: 63px;
		}

		img {
			max-height: 100%;
			max-width: 100%;
		}

	}

	.g-cart-toast-message {
		font-size: $font-size-small;
		font-weight: $font-weight-bold;

		&.is-success {
			color: $message-success-text;
		}

		&.is-warning {
			color: $message-warning-text;
		}

		@include media( ">large" ) {
			font-size: $font-size-medium;
		}
	}

	.g-cart-toast-name {
		color: $text-color-xdark;
		font-size: $font-size-small;
	}

	.g-cart-toast-cta {
		font-size: 14px;
		font-weight: $font-weight-semibold;
		letter-spacing: 0.03em;
		line-height: $font-size-medium;
		max-width: 109px;
		padding: 15px 10px;

		@include media( ">large" ) {
			padding: 10px 13px;
		}
	}

	@media ( prefers-reduced-motion: no-preference ) {
		.slide-enter-active,
		.slide-leave-active {
			transition: top 0.5s;

			@include media( ">large" ) {
				transition: right 0.5s;
			}
		}
	}

	.slide-enter,
	.slide-leave-to {
		top: -100%;

		@include media( ">large" ) {
			right: -100%;
		}
	}

</style>
